//NotificationContainer.jsx
import { Paper, Typography } from "@mui/material";
import NotificationView from "./NotificationComponent/NotificationView";

const NotificationContainer = () => {
  return (
    <Paper elevation={3} style={{ padding: "20px" }}>
      <Typography variant="h5" align="left" gutterBottom>
        Email Preview Management
      </Typography>
      <NotificationView />
    </Paper>
  );
};

export default NotificationContainer;
